import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SettingsService } from 'src/app/services/services.index';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  courses_db:any = [];
  coupons:any = [];
  main:any = [];
  courses:any = [];

  constructor(
    public router: Router,
    private settings: SettingsService,
  ) { }
  
  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.courses_db = this.settings['local']['courses'];
    this.coupons = this.settings['local']['coupons'];
    if(this.courses_db['length'] == 0 || this.courses_db['length'] == undefined){
      setTimeout(() => {
        this.settings.loadSettings();
        this.courses_db = this.settings['local']['courses'];
        this.coupons = this.settings['local']['coupons'];
  
        let numero = 0;
        for (let i = this.courses_db['length'] - 1; i >= 0; i--) {
          if (this.courses_db[i]['mainOrder'] > numero) {
            numero = this.courses_db[i]['mainOrder'];
            this.main = this.courses_db[i]; 
          }
          this.courses.push(this.courses_db[i]);
        };

        this.courses.sort(function(a:any, b:any){
          return  b.mainOrder - a.mainOrder;
        })
      }, 1000);
    }else{
      let numero = 0;
      for (let i = this.courses_db['length'] - 1; i >= 0; i--) {
        if (this.courses_db[i]['mainOrder'] > numero) {
          numero = this.courses_db[i]['mainOrder'];
          this.main = this.courses_db[i]; 
        }
        this.courses.push(this.courses_db[i]);
      };

      this.courses.sort(function(a:any, b:any){
        return  b.mainOrder - a.mainOrder;
      })
  
      this.settings['local']['page'] = 'inicio';
      this.settings.saveSettings();
    }
  }

  goToPage(param:any) {
    this.settings['local']['course'] = param;
    this.settings.saveSettings();
    this.router.navigate(['/curso']);
  };

  goToCourse(param:any) {
    let url;
    if (!param['free']) {
      if (param['cupon']) {
        url = param['url'] + param['cupon'];
      } else if (this.coupons[0]) {
        url = param['url'] + this.coupons[0];
      } else if (param['cuponDefault']) {
        url = param['url'] + param['cuponDefault'];
      } 
    } else {
      url = param['urlRef']
    }

    window.open(url, '_blank');
  };

}
